$(document).ready(function() {
    // Tooltip
    var oc_tooltip = function() {
        // Get tooltip instance
        tooltip = bootstrap.Tooltip.getInstance(this);

        if (!tooltip) {
            // Apply to current element
            tooltip = bootstrap.Tooltip.getOrCreateInstance(this);
            tooltip.show();
        }
    }

    $(document).on('mouseenter', '[data-bs-toggle=\'tooltip\']', oc_tooltip);

    $(document).on('click', 'button', function() {
        $('.tooltip').remove();
    });

    $('#alert').observe(function() {
        window.setTimeout(function() {
            $('#alert .alert-dismissible').fadeTo(3000, 0, function() {
                $(this).remove();
            });
        }, 3000);
    });
});

document.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth < 1023) {
        document.querySelectorAll('.dropdown-submenu > .dropdown-toggle').forEach(function(el) {
            el.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var sub = this.nextElementSibling;
            if (sub) { 
                sub.classList.toggle('show'); }
            });
        });
    }
});

// Button
$(document).ready(function() {
    +function($) {
        $.fn.button = function(state) {
            return this.each(function() {
                var element = this;

                if (state == 'loading') {
                    this.html = $(element).html();
                    this.state = $(element).prop('disabled');

                    $(element).prop('disabled', true).width($(element).width()).html('<i class="fa-solid fa-circle-notch fa-spin text-light"></i>');
                }

                if (state == 'reset') {
                    $(element).prop('disabled', this.state).width('').html(this.html);
                }
            });
        };
    }(jQuery);
});

// Forms
$(document).on('submit', 'form', function (e) {
    var element = this;
    var button = (e.originalEvent !== undefined && e.originalEvent.submitter !== undefined) ? e.originalEvent.submitter : '';

    if ($(element).attr('data-oc-toggle') == 'ajax' || $(button).attr('data-oc-toggle') == 'ajax') {
        e.preventDefault();

        var form = e.target;
        var action = $(button).attr('formaction') || $(form).attr('action');
        var method = $(button).attr('formmethod') || $(form).attr('method') || 'post';
        var enctype = $(button).attr('formenctype') || $(form).attr('enctype') || 'application/x-www-form-urlencoded';

        /* console.log(e);
        console.log(element);
        console.log('action ' + action);
        console.log('button ' + button);
        console.log('method ' + method);
        console.log('enctype ' + enctype);
        console.log($(element).serialize()); */

        // https://github.com/opencart/opencart/issues/9690
        if (typeof CKEDITOR != 'undefined') {
            for (instance in CKEDITOR.instances) {
                CKEDITOR.instances[instance].updateElement();
            }
        }

        $.ajax({
            url: action.replaceAll('&amp;', '&'),
            type: method,
            data: $(form).serialize(),
            dataType: 'json',
            contentType: enctype,
            beforeSend: function () {
                $(button).button('loading');
            },
            complete: function () {
                $(button).button('reset');
            },
            success: function (json, textStatus) {
                console.log(json);
                console.log(textStatus);

                $('.alert-dismissible').remove();
                $(element).find('.is-invalid').removeClass('is-invalid');
                $(element).find('.invalid-feedback').removeClass('d-block');

                if (json['redirect']) {
                    location = json['redirect'];
                }

                if (typeof json['error'] == 'string') {
                    window.showToast(json['error'], 'error');
                }

                if (typeof json['error'] == 'object') {
                    if (json['error']['warning']) {
                        window.showToast(json['error']['warning'], 'error');
                    }

                    for (key in json['error']) {
                        $('#input-' + key.replaceAll('_', '-')).addClass('is-invalid').find('.form-control, .form-select, .form-check-input, .form-check-label').addClass('is-invalid');
                        $('#error-' + key.replaceAll('_', '-')).html(json['error'][key]).addClass('d-block');
                    }
                }

                if (json['success']) {
                    window.showToast(json['success'], 'success');

                    // Refresh
                    var url = $(form).attr('data-oc-load');
                    var target = $(form).attr('data-oc-target');

                    if (url !== undefined && target !== undefined) {
                        $(target).load(url);
                    }
                }

                // Replace any form values that correspond to form names.
                for (key in json) {
                    $(element).find('[name=\'' + key + '\']').val(json[key]);
                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
            }
        });
    }
});

// Upload
$(document).on('click', 'button[data-oc-toggle=\'upload\']', function() {
    var element = this;

    if (!$(element).prop('disabled')) {
        $('#form-upload').remove();

        $('body').prepend('<form enctype="multipart/form-data" id="form-upload" style="display: none;"><input type="file" name="file" value=""/></form>');

        $('#form-upload input[name=\'file\']').trigger('click');

        $('#form-upload input[name=\'file\']').on('change', function(e) {
            if ((this.files[0].size / 1024) > $(element).attr('data-oc-size-max')) {
                alert($(element).attr('data-oc-size-error'));

                $(this).val('');
            }
        });

        if (typeof timer !== 'undefined') {
            clearInterval(timer);
        }

        var timer = setInterval(function() {
            if ($('#form-upload input[name=\'file\']').val() != '') {
                clearInterval(timer);

                $.ajax({
                    url: $(element).attr('data-oc-url'),
                    type: 'post',
                    data: new FormData($('#form-upload')[0]),
                    dataType: 'json',
                    cache: false,
                    contentType: false,
                    processData: false,
                    beforeSend: function() {
                        $(element).button('loading');
                    },
                    complete: function() {
                        $(element).button('reset');
                    },
                    success: function(json) {
                        console.log(json);

                        if (json['error']) {
                            alert(json['error']);
                        }

                        if (json['success']) {
                            alert(json['success']);
                        }

                        if (json['code']) {
                            $($(element).attr('data-oc-target')).attr('value', json['code']);
                        }
                    },
                    error: function(xhr, ajaxOptions, thrownError) {
                        console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
                    }
                });
            }
        }, 500);
    }
});

$(document).ready(function() {
    // Currency
    $('#form-currency .dropdown-item').on('click', function(e) {
        e.preventDefault();

        $('#form-currency input[name=\'code\']').val($(this).attr('href'));

        $('#form-currency').submit();
    });

    // Language
    $('#form-language .language-select').on('click', function(e) {
        e.preventDefault();

        $('#form-language input[name=\'code\']').val($(this).data('name'));

        console.log($(this).data('name'));

        $('#form-language').submit();
    });

    // Product List
    /* $('#button-list').on('click', function() {
        var element = this;

        $('#product-list').attr('class', 'product-list row row-cols-1');

        $('#button-grid').removeClass('active');
        $('#button-list').addClass('active');

        localStorage.setItem('display', 'list');
    }); */

    // Product Grid
    /* $('#button-grid').on('click', function() {
        var element = this;

        // What a shame bootstrap does not take into account dynamically loaded columns
        $('#product-list').attr('class', 'product-rows row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-3');

        $('#button-list').removeClass('active');
        $('#button-grid').addClass('active');

        localStorage.setItem('display', 'grid');
    }); */

    // Local Storage
    /* if (localStorage.getItem('display') == 'list') {
        $('#product-list').attr('class', 'product-list row row-cols-1 product-list');
        $('#button-list').addClass('active');
    } else {
        $('#product-list').attr('class', 'product-rows row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-3');
        $('#button-grid').addClass('active');
    } */

    /* Agree to Terms */
    $('body').on('click', '.modal-link', function(e) {
        e.preventDefault();

        var element = this;

        $('#modal-information').remove();

        $.ajax({
            url: $(element).attr('href'),
            dataType: 'html',
            success: function(html) {
                $('body').append(html);

                $('#modal-information').modal('show');
            }
        });
    });

    // Cookie Policy
    $('#cookie button').on('click', function() {
        var element = this;

        $.ajax({
            url: $(this).val(),
            type: 'get',
            dataType: 'json',
            beforeSend: function() {
                $(element).button('loading');
            },
            complete: function() {
                $(element).button('reset');
            },
            success: function(json) {
                if (json['success']) {
                    $('#cookie').fadeOut(400, function() {
                        $('#cookie').remove();
                    });
                }
            },
            error: function(xhr, ajaxOptions, thrownError) {
                console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
            }
        });
    });
});

/* Global toast popup — replaces #alert prepend pattern */
window.showToast = function(message, type) {
    var el = document.getElementById('cart-toast');
    if (!el) return;

    var variant = (type === 'error' || type === 'danger') ? 'error' : 'success';
    var iconEl = el.querySelector('.cart-toast__icon i');
    var msgEl = el.querySelector('.cart-toast__message');

    el.classList.remove('cart-toast--success', 'cart-toast--error');
    el.classList.add('cart-toast--' + variant);

    if (iconEl) {
        iconEl.className = (variant === 'error') ? 'fa-solid fa-xmark' : 'fa-solid fa-check';
    }
    if (msgEl) {
        msgEl.innerHTML = message || '';
    }

    el.classList.add('is-visible');
    el.setAttribute('aria-hidden', 'false');

    clearTimeout(window._cartToastTimer);
    window._cartToastTimer = setTimeout(function() {
        el.classList.remove('is-visible');
        el.setAttribute('aria-hidden', 'true');
    }, 2000);
};

/* Backwards-compatible alias */
window.showCartToast = function(message) {
    window.showToast(message, 'success');
};

/**
 * API dùng chung cho các script animate-on-load khác (heading-splittext.js, scroll-reveal.js...):
 * chạy callback sau khi trang đã THỰC SỰ hiện ra cho người dùng thấy (overlay #page-loader đã ẩn
 * hẳn + #page-content đã bắt đầu fade-in — xem 'qh:page-reveal' bên dưới). Nếu chạy animation
 * ngay từ DOMContentLoaded như bình thường, phần tử above-the-fold sẽ animate xong trong lúc
 * còn bị overlay che, user không kịp thấy hiệu ứng.
 */
window.qhOnPageReveal = (function () {
    var pageRevealed = false;

    // Nhớ lại trạng thái đã reveal — nếu không, 1 lời gọi qhOnPageReveal() TRỄ (sau khi trang đã
    // hiện ra từ lâu, VD gọi thủ công cho nội dung vừa chèn thêm bằng JS) sẽ không bao giờ bắt được
    // sự kiện 'qh:page-reveal' đã bắn từ trước, phải chờ tới hết 6s fallback bên dưới mới chạy.
    document.addEventListener('qh:page-reveal', function () {
        pageRevealed = true;
    });

    return function (callback) {
        if (typeof callback !== 'function') return;

        if (pageRevealed) {
            callback();
            return;
        }

        var already = false;

        function run() {
            if (already) return;
            already = true;
            callback();
        }

        document.addEventListener('qh:page-reveal', run, { once: true });

        // An toàn: nếu vì lý do gì đó 'qh:page-reveal' không bao giờ bắn ra (thiếu #page-loader/
        // #page-content, lỗi JS khác...) — vẫn chạy callback sau tối đa 9s để animation không bị
        // kẹt vĩnh viễn (main.js tự ép reveal() sau tối đa 8s + 0.6s, xem bên dưới).
        setTimeout(run, 9000);
    };
})();

/**
 * Preloader (#page-loader, xem common/page_loader.twig): giữ màn che tới khi trang tải xong và logo
 * vẽ xong → kéo màn che lên, hiện #page-content → gỡ hẳn #page-loader khỏi DOM cho trang gọn
 * (khối SVG logo khá nặng, không cần giữ lại sau khi đã dùng xong).
 */
(function () {
    // main.js được nạp bằng <script> đồng bộ trong <head> (xem header.twig), tức là chạy
    // TRƯỚC KHI <body> — và do đó #page-loader/#page-content — tồn tại trong DOM. Vì vậy mọi
    // thứ (kể cả tra getElementById) phải nằm trong init(), chỉ chạy sau khi DOM đã parse xong.
    function init() {
        var loader = document.getElementById('page-loader');
        var content = document.getElementById('page-content');
        if (!loader || !content) return;

        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var LOADER_MIN = reduceMotion ? 400 : 2900;    // khớp $loader-duration trong _loader.scss — chờ logo vẽ xong
        var LOADER_MAX = 8000;                         // không bao giờ giữ màn che quá 8s
        var LOADER_EXIT = reduceMotion ? 0 : 600;      // màn che bắt đầu kéo lên (.25s delay) → báo page-reveal
        var LOADER_REMOVE = reduceMotion ? 450 : 1300; // khớp transition của .page-loader.is-hidden (.25s + 1s)
        var revealed = false;

        function now() {
            return (window.performance && performance.now) ? performance.now() : 0;
        }

        function removeLoader() {
            if (loader && loader.parentNode) {
                loader.parentNode.removeChild(loader);
            }
            loader = null;
        }

        function reveal(instant) {
            if (revealed) return;
            revealed = true;

            paint(100);
            loader.classList.add('is-hidden');
            document.body.classList.remove('is-loading');
            // Màn che kéo lên từ dưới → nội dung phải hiện sẵn bên dưới, không chờ overlay ẩn hẳn.
            content.classList.add('is-visible');

            if (instant) {
                removeLoader();
                document.dispatchEvent(new CustomEvent('qh:page-reveal'));
                return;
            }

            // Báo cho các script animate-on-load khác (heading-splittext.js, scroll-reveal.js...)
            // khi màn che đã bắt đầu mở — tránh animation above-the-fold chạy "vô hình" lúc còn bị che.
            setTimeout(function () {
                document.dispatchEvent(new CustomEvent('qh:page-reveal'));
            }, LOADER_EXIT);

            setTimeout(removeLoader, LOADER_REMOVE);
        }

        // ---- Thanh tiến độ + % (giống preloader Pachira) ----
        // Trình duyệt không cho biết % tải thật → tiến độ chạy theo thời gian, dừng ở 90% cho tới khi
        // window load xong; khi đó chạy nốt tới 100% (không sớm hơn LOADER_MIN — logo phải vẽ xong),
        // giữ 100% một nhịp rồi mới mở màn che.
        var bar = loader.querySelector('[data-loader-bar]');
        var count = loader.querySelector('[data-loader-count]');
        var WAIT_CAP = 90;
        var FINISH_MIN = 450; // ms tối thiểu để chạy nốt từ mức hiện tại → 100%
        var HOLD = 150;       // ms giữ ở 100% trước khi mở màn che
        var shown = 0;
        var finish = null;    // { from, start, end } khi đã load xong

        function paint(value) {
            shown = value;
            if (bar) bar.style.transform = 'scaleX(' + (value / 100) + ')';
            if (count) count.textContent = Math.round(value) + '%';
        }

        function easeInOut(t) {
            return t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
        }

        function easeOut(t) {
            return 1 - Math.pow(1 - t, 3);
        }

        function tick() {
            if (revealed) return;

            var time = now();

            if (finish) {
                var duration = finish.end - finish.start;
                var t = Math.min((time - finish.start) / duration, 1);
                // Load xong sớm → quãng chạy dài, easeOut sẽ vọt lên ~100% rồi đứng chờ → dùng easeInOut cho đều.
                paint(finish.from + (100 - finish.from) * (duration > FINISH_MIN * 2 ? easeInOut(t) : easeOut(t)));

                if (t >= 1) return;
            } else {
                paint(Math.max(shown, easeInOut(Math.min(time / LOADER_MIN, 1)) * WAIT_CAP));
            }

            requestAnimationFrame(tick);
        }

        // performance.now() tính từ lúc bắt đầu điều hướng ≈ lúc animation CSS bắt đầu chạy.
        // Mở màn che bằng setTimeout, không đợi tick(): tab mở ở nền không chạy requestAnimationFrame,
        // nếu để tick() gọi reveal thì màn che kẹt tới LOADER_MAX.
        function onLoad() {
            var time = now();
            finish = { from: shown, start: time, end: Math.max(LOADER_MIN, time + FINISH_MIN) };
            setTimeout(reveal, finish.end - time + HOLD);
        }

        if (document.readyState === 'complete') {
            onLoad();
        } else {
            window.addEventListener('load', onLoad);
        }

        requestAnimationFrame(tick);

        setTimeout(reveal, Math.max(LOADER_MAX - now(), 0));

        // Quay lại từ bfcache (nút back/forward) khi màn che còn dở — bỏ qua animation
        window.addEventListener('pageshow', function (e) {
            if (e.persisted) reveal(true);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();